import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { cn } from 'src/shared/utils/cn'

import SettingsSubtitle from './settings-subtitle'
import SettingsTitle from './settings-title'

type SettingsHeaderProps = {
  title: string
  subtitle: string
  rightContent?: React.ReactNode
  className?: string
}

const SettingsHeader = ({ title, subtitle, rightContent, className }: SettingsHeaderProps) => {
  const { isTabletOrSmaller, isDesktop } = useBreakpoint()

  return (
    <div
      className={cn(
        'flex flex-row justify-between gap-4 pb-6 pt-10',
        isTabletOrSmaller ? 'px-5 pt-5' : 'px-[70px] pt-[70px]',
        isDesktop && 'px-[80px]',
        className,
      )}
    >
      <div className={cn('flex flex-col items-start gap-2.5')}>
        <SettingsTitle title={title} />
        <SettingsSubtitle subtitle={subtitle} />
      </div>
      {rightContent && <div className="flex items-start justify-end">{rightContent}</div>}
    </div>
  )
}

export default SettingsHeader
